export default __webpack_public_path__ + "static/media/complaint.038ce197.png";